<div>
  <div class="page-content-inner-wrap">
    <div class="row">
      <div class="exp-contr">
        <section class="card-style-sec inner-page-card-sec">
          <div class="col-9">
            @if (sensorLabResult) {
              <app-gravimetric-results class="w-100"></app-gravimetric-results>
            }
          </div>
        </section>
        @if (taskAssignmentDataSource && taskAssignmentDataSource.length > 0) {
          <section class="card-style-sec shift-exposures-table-sec exp-rec">
            <div>
              <div class="row exposures-table-comment-row">
                <div class="col-12" (clickOutside)="clearTaskRanges($event)">
                  <div class="card-inner-main-div">
                    <div class="card-main-title">
                      <h4 class="card-title">{{ 'Exposure Contributions' | translate }}</h4>
                    </div>
                    <div class="tableColStyle without-borders-table">
                      @if (loadingAssessments) {
                        <div class="comments-loader">
                          <img src="assets/images/loader.gif">
                        </div>
                      }
                      @if (!loadingAssessments) {
                        <div class="table-responsive">
                          <table mat-table
                            [dataSource]="taskAssignmentDataSource" multiTemplateDataRows
                            class="mat-elevation-z8">
                            @for (column of taskAssignmentColumnsToDisplay; track trackByIndex(j); let j = $index) {
                              <ng-container matColumnDef="{{column}}">
                                <ng-container>
                                  <th mat-header-cell *matHeaderCellDef style="background-color: white;">
                                    <span class="font-700">{{taskAssignmentColumnsToDisplayStr[j]}}</span>
                                  </th>
                                  <td mat-cell *matCellDef="let element; let i = dataIndex;"
                                    style="{{(j==0) ? 'border-left: 6px solid '+ taskColor[element['taskName']] +' !important;' : ''}} {{(selectedTaskName == element['taskName'] && !taskRangeVisibility) ? 'background: '+ taskSelectColor[element['taskName']] +' !important;' : ''}}">
                                    @if ((column.includes('location')) && element[column].length > 1) {
                                      <span class="multiple-hover-popup link-cursor">MULTIPLE
                                        <div class="multiple-popup">
                                          <table style="width:100%">
                                            <tbody>
                                              <tr>
                                                <th>
                                                  <div class="img-div" style="text-align: center;"><img src="assets/images/location.png"></div>location
                                                </th>
                                                <th>
                                                  <div class="img-div" style="text-align: center;"><img src="assets/images/Time-shift.png"></div>Time on shift:
                                                </th>
                                                <th>
                                                  <div class="img-div" style=" text-align: center;"><img src="assets/images/contribution.png"></div>Mass contribution
                                                </th>
                                              </tr>
                                              @for (location of element.locationAssignments; track trackByIndex($index)) {
                                                <tr >
                                                  <td>{{location.locationName}}</td>
                                                  <td>{{((location.timeAtLocation/sensorAssignmentData.totalTime)* 100).toFixed(2)}} %</td>
                                                  <td>{{location.massContributionPercentage ? location.massContributionPercentage : ' - '}}</td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                        </div>
                                      </span>
                                    }
                                    @if ((column.includes('location')) && element[column].length == 1) {
                                      <span class="multiple-hover-popup link-cursor">{{element.locations[0].locationName}}</span>
                                    }
                                    @if (!(column.includes('location')) || !element[column].length) {
                                      <span > {{element[column] ? element[column] : ' - '}} </span>
                                    }
                                  </td>
                                </ng-container>
                              </ng-container>
                            }
                            <ng-container matColumnDef="timeOnTaskPercentage">
                              <th mat-header-cell *matHeaderCellDef style="width: 170px; text-align: right; background: white;">
                                <span class="font-700"> {{ 'Time on Shift %' | translate }} </span>
                              </th>
                              <td mat-cell *matCellDef="let element; let i = dataIndex;"
                                style="{{(selectedTaskName == element['taskName'] && !taskRangeVisibility) ? 'background: '+ taskSelectColor[element['taskName']] +' !important;' : ''}}">
                                <div class="percentage-txt-div w-100 exposure">
                                  <div class="percent-box-outer"><span class="percent-box sky-blue-bg"
                                  [style.width.%]="element.timeOnShiftPercentageNum"></span></div><span
                                class="pl-2">{{element.timeOnShiftPercent}}</span>
                              </div>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="massContributionPercentage">
                            <th mat-header-cell *matHeaderCellDef style="background-color: white;">
                              <span class="font-700"> {{ 'Mass Contribution %' | translate }} </span>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = dataIndex;" style="{{(selectedTaskName == element['taskName'] && !taskRangeVisibility) ? 'background: '+ taskSelectColor[element['taskName']] +' !important;' : ''}}">
                              <div class="percentage-txt-div w-100 exposure">
                                <div class="percent-box-outer"><span class="percent-box purple-bg" [style.width.%]="element.massContributionPercentageNum"></span></div><span class="pl-2">{{element.massContributionPercentage}}</span>
                              </div>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="ppeAssignments">
                            <th mat-header-cell *matHeaderCellDef style="background-color: white;">
                              <span class="font-700"> {{ 'PPE' | translate }} </span>
                            </th>
                            <td mat-cell *matCellDef="let element; let i = dataIndex;" style="{{(selectedTaskName == element['taskName'] && !taskRangeVisibility) ? 'background: '+ taskSelectColor[element['taskName']] +' !important;' : ''}}">
                              @if (element['ppeAssignments']?.length) {
                                <span class="table-down-arrow" style="height: 50px; width: 50px;">
                                  <img src="assets/images/Check.svg">
                                </span>
                              } @else {
                                <span class="table-down-arrow" style="height: 50px; width: 50px;">
                                  <img src="assets/images/CheckX.svg">
                                </span>
                              }
                              @if (showPPE[i]) {
                                <div class="card-box-dd chart-filter p-0" (mouseenter)="showHidePPE(i, true)"  (mouseleave)="showHidePPE(i, false)">
                                  @for (ppe of element['ppeAssignments']; track trackByIndex($index)) {
                                    <div>
                                      @if (ppe.ppeType == 0) {
                                        <div class="ppe-info row no-gutters vertical-align-middle">
                                          <div class="col-md-12 m-0">
                                            <div class="m-2">
                                              <img src="assets/images/mask.png" height="43" width="43">
                                            </div>
                                            <div class="h6 font-700">{{ppe.ppeName}}</div>
                                          </div>
                                        </div>
                                      }
                                      @if (ppe.ppeType == 1) {
                                        <div class="ppe-info row no-gutters vertical-align-middle">
                                          <div class="col-md-12 m-0">
                                            <div class="m-2">
                                              <img src="assets/images/hearing.png" height="43" width="43">
                                            </div>
                                            <div class="h6 font-700">{{ppe.ppeName}}</div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="taskAssignmentColumnsToDisplayWithExpand"></tr>
                          <tr mat-row *matRowDef="let element; columns: taskAssignmentColumnsToDisplayWithExpand;"
                            class="exposure-element-row"
                            [class.exposure-expanded-row]="taskAssignmentExpandedElement === element"
                            (click)="showTaskRange(taskRangeVisibility,element.taskName); (element?.locationAssignments?.length ? (taskAssignmentExpandedElement = taskAssignmentExpandedElement === element ? null : element) : element)">
                          </tr>
                        </table>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
      @if (taskAssignmentDataSource && taskAssignmentDataSource.length > 0) {
        <hr class="w-100 hr-chart">
      }
      @if (allSensorRecords && allSensorRecords.length > 0) {
        <div class="card-main-title card-marg">
          <h4 class="card-title">{{ 'Exposure Recorded' | translate }}</h4>
        </div>
      }
      <section class="expo-rec">
        <div>
          <div class="pmgraphOuter" (clickOutside)="clearCommentRanges($event)">
            <div [ngClass]="selectedTab===1?'show-graph-tab':'hide-graph-tab'">
              @if (loadCommentsAndNotes) {
                <div class="comments-loader">
                  <img src="assets/images/loader.gif">
                </div>
              }
              <app-exposure-graph class="graph-height" [selectedTab]="selectedTab" [loadCommentsAndNotes]="loadCommentsAndNotes"
                [isVideoChartHidden]="isVideoChartHidden" [CHART_VIDEO_DIV_ID]="CHART_VIDEO_DIV_ID"
                [showChartFilter]="showChartFilter" [chart]="chart" [CHART_DIV_ID]="CHART_DIV_ID"
                [taskRangeVisibility]="taskRangeVisibility" [chartDetails]="chartDetails">
              </app-exposure-graph>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div><!--==page-content-inner wrapper end==-->
</div><!--======page-content-wrapper end======-->
</div>
